<template>
  <v-dialog v-model="visible" max-width="550" persistent>
    <v-card>
      <v-card-title class="text-h6"> Ny länk </v-card-title>

      <v-card-text>
        <v-text-field
          label="Text"
          placeholder="Länk-text"
          clearable
          outlined
          v-model="text"
        ></v-text-field>
        <v-text-field
          label="Url"
          placeholder="https://..."
          clearable
          outlined
          v-model="url"
        ></v-text-field>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn text :to="{ name: 'art-info-links' }"> Avbryt </v-btn>

        <v-btn color="primary" :disabled="!text || !url" :loading="loading" @click="save">
          Spara
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ArtLinkCreate',
  props: {
    id: { type: [Number, String] },
  },
  data() {
    return {
      visible: true,
      text: '',
      url: '',
      loading: false,
    }
  },
  computed: {},
  methods: {
    save() {
      this.$emit('link:add', { name_sve: this.text, url: this.url })
      this.$router.replace({ name: 'art-info-links', params: { id: +this.id } })
    },
  },
}
</script>

<style lang="scss" scoped></style>
